import FileSaver from 'file-saver';
import JSZip from 'jszip';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

function convertJsonToExcel(data) {
  if (!data || !data.columns || !data.data) {
    console.error('Invalid data structure for Excel conversion:', data);
    // Create empty workbook with default headers
    const worksheet = XLSX.utils.json_to_sheet([]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Scan Stats');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    return new Blob([excelBuffer], { type: EXCEL_TYPE });
  }

  // flatten the data first
  const flattenData = flattenJsonObject(data);
  const worksheet = XLSX.utils.json_to_sheet(flattenData);
  //   XLXS.utils.book_append_sheet(workbook, worksheet, 'Scan Statistics');

  // fix headers
  XLSX.utils.sheet_add_aoa(worksheet, [data.columns], { origin: 'A1' });

  /* calculate column width */
  worksheet['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 40 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Scan Stats');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  const excelFile = new Blob([excelBuffer], { type: EXCEL_TYPE });
  return excelFile;
}

// the list of location is sent as JSON object of key-value: location-count
// for each location, it is represented as a separate column in the row
function flattenJsonObject(jsonData) {
  if (!jsonData || !jsonData.data) {
    console.error('Invalid data structure for Excel conversion:', jsonData);
    return [];
  }
  
  const { data } = jsonData;

  const result = new Array(data.length);
  let index = 0;
  for (const row of data) {
    let newObj = {
      batchNumber: row.batchNumber,
      aggregateScan: row.aggregateScan,
      correctScan: row.correctScan,
      wrongScan: row.wrongScan
      // locations: convertJsonToString(row.locations)
    };

    // add each location as a new column in the row data
    newObj = addLocationAsColumnToRow(newObj, row.locations);
    result[index] = newObj;
    index++;
  }
  console.log(result);
  return result;
}

/**
 * With the json object containing locations, add each key-value pair to the excel row
 * Params:  rowObj : The JSON object representing the row data
 *          locations: The list of locations and count
 * Return: The updated JSON object such that each location is a new column in the row
 */
function addLocationAsColumnToRow(rowObj, locations) {
  let locationIndex = 1;
  for (const [location, count] of Object.entries(locations)) {
    rowObj[`Location ${locationIndex}`] = location + ': ' + count;
    locationIndex++;
  }
  return rowObj;
}

/**
 * Zip the data and downlaod the compressed file.
 * @param {} data : Files to be zipped
 */
export function zipAndDownload(data, issueCertsEventName) {
  const zip = new JSZip();

  const addEntries = (entries, currentPath = '') => {
    if (!entries || typeof entries !== 'object') {
      return;
    }

    Object.entries(entries).forEach(([name, content]) => {
      const path = currentPath ? `${currentPath}/${name}` : name;

      if (content && typeof content === 'object' && !Array.isArray(content)) {
        addEntries(content, path);
      } else if (typeof content === 'string') {
        zip.file(path, content, { base64: true });
      } else {
        console.warn(`Skipping unsupported zip content for "${path}" of type "${typeof content}"`);
      }
    });
  };

  const zipEntries =
    (data && data.body && (data.body.zip || data.body.data)) ||
    (data && data.body) ||
    {};

  addEntries(zipEntries);

  zip.generateAsync({ type: 'blob' }).then(function(content) {
    FileSaver.saveAs(content, `qr_${issueCertsEventName}.zip`);
  });
}

/**
 * Prepare the data from json object to excel file.
 * @param {*} data: Object to be processed and downloaded, need to contain a key specifying the column name in the excel files
 * @param {string} productionName: Production Name of the data
 */
export function processAndDownloadExcel(data, productionName) {
  const excelFile = convertJsonToExcel(data);
  FileSaver.saveAs(excelFile, `Scan Stats for ${productionName}.xlsx`);
}
